/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";

export const pollQuizLeaderboardServiceMeta: Meta<typeof pollQuizLeaderboardService> = {
	getPosition: ["GET", "/api/v1/poll/quiz/leaderboard/position/:gameId"],
};

// Feature.Poll.Controllers.ApiV1PollQuizLeaderboardController
export const pollQuizLeaderboardService = {
	async getPosition(gameId: /* Guid */ string) {
		return await http.fetch<undefined, undefined>(pollQuizLeaderboardServiceMeta.getPosition, { params: { gameId } });
	},
};
